import { createGetIsDropTargetItem, getDraggingInfo } from './selectors.tsx';
import { createSelectorHook, createHigherLevelHook } from './utils.tsx';

export const useDraggingInfo = createSelectorHook(getDraggingInfo);

export const useIsDropTargetItem = createHigherLevelHook(createGetIsDropTargetItem);
